<tlc-churn-flow-step-template [currentStep]="3" [reasonInfoboxMessage]="infoboxMessage()">
  <div class="left">
    <tlc-churn-flow-reason-template
      [heading]="'tlc.churn_flow.steps.too_complicated.heading' | translate"
      [subheading]="'tlc.churn_flow.steps.too_complicated.subheading' | translate"
      (stayWithTellent)="stayWithTellent()"
      (stillWantToCancel)="stillWantToCancel()"
    >
      <div class="solutions-container">
        <tlc-churn-flow-solution-card
          [iconVariant]="bookConsultation.iconVariant"
          [title]="bookConsultation.title"
          [subtitle]="bookConsultation.subtitle"
          [incentives]="bookConsultation.incentives"
        >
          <div class="actions">
            <rt-button variant="tertiary" (click)="bookConsultationAction()">
              <rt-icon name="open-in-new" />
              <span>{{ bookConsultation.ctaText }}</span>
            </rt-button>
          </div>
        </tlc-churn-flow-solution-card>

        <tlc-churn-flow-solution-card
          [iconVariant]="joinTrainingSession.iconVariant"
          [title]="joinTrainingSession.title"
          [subtitle]="joinTrainingSession.subtitle"
          [incentives]="joinTrainingSession.incentives"
        >
          <div class="actions">
            <a
              rt-button
              variant="tertiary"
              [href]="getTrainingScheduleLink()"
              target="_blank"
              (click)="trackAlternativeEvent('join_training')"
            >
              <rt-icon name="open-in-new" />
              <span>{{ joinTrainingSession.ctaText }}</span>
            </a>
          </div>
        </tlc-churn-flow-solution-card>

        <tlc-churn-flow-solution-card
          [iconVariant]="seeWhatsComing.iconVariant"
          [title]="seeWhatsComing.title"
          [subtitle]="seeWhatsComing.subtitle"
          [incentives]="seeWhatsComing.incentives"
        >
          <div class="actions">
            <a
              rt-button
              variant="tertiary"
              href="https://support.tellent.com/articles/10368103"
              target="_blank"
              (click)="trackAlternativeEvent('explore_roadmap')"
            >
              <rt-icon name="open-in-new" />
              <span>{{ seeWhatsComing.ctaText }}</span>
            </a>
          </div>
        </tlc-churn-flow-solution-card>
      </div>
    </tlc-churn-flow-reason-template>
  </div>

  <div class="right">
    <tlc-churn-flow-insights />
  </div>
</tlc-churn-flow-step-template>
